import React, { useEffect, useState } from 'react'
import './TarifsCards.scss'
import TarifCard from './TarifCard/TarifCard'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css"; 
import { NextArrow, PrevArrow } from './TarifCard/Arrows/Arrows';
import Form from '../../../General/Form/Form';
import TarifCustomCard from './TarifCustomCard/TarifCustomCard';
import RouterCard from '../../../Router/RouterSlider/RouterCards/RouterCard/RouterCard';
import { useLocation } from 'react-router-dom';
import ConnectModal from '../../../General/Components/ConnectModal/ConnectModal';
import TarifsCardsMobile, { normalizeTariff, normalizeGalleryItem } from './TarifsCardsMobile/TarifsCardsMobile';
import { useIsMobile } from '../useIsMobile';

const fillSlides = (arr, minCount) => {
  if (!arr?.length) return [];
  let result = [...arr];
  while (result.length < minCount) result = [...result, ...arr];
  return result;
};

const TarifsCards = ({ tarifCards, tarifIptvData, tarifAdditionallyData, activeTitle, tarifYearCards, tarifActionCards }) => {
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  // IP TV «Базовый» на мобилке — та же ConnectModal, что в TarifCustomCard.
  const [iptvModal, setIptvModal] = useState({ open: false, serviceName: '' });
  const isMobile = useIsMobile();

  useEffect(() => {
    setShowModal(location.pathname === '/cash');
  }, []);

  const normalizedYearCards = fillSlides(tarifYearCards, 3);
  const iptvCount = tarifIptvData?.length ?? 0;
  const actionCount = tarifActionCards?.length ?? 0;
  /*
    Акций всего две. Раньше их добивали копиями до трёх, чтобы
    react-slick не рвал трек, — на экране получалось четыре карточки,
    и они ещё и ехали по кругу. Двум карточкам слайдер не нужен вовсе:
    показываем их статическим рядом, как IP TV с одной-двумя позициями.
  */
  const actionsStatic = actionCount > 0 && actionCount <= 2;

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1280,
        settings: { slidesToShow: 2, slidesToScroll: 1, arrows: false, dots: true },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1, slidesToScroll: 1, arrows: false, dots: true },
      },
    ],
  };

  useEffect(() => {
    // Костыль нужен только react-slick (десктоп/планшет): пересчёт раскладки
    // при смене категории. В мобильной ветке слайдер не монтируется.
    if (!isMobile) window.dispatchEvent(new Event('resize'));
  }, [activeTitle, isMobile]);

  const renderIptvCard = (e) => e.iptv
    ? <RouterCard key={e.id} data={e} setActive={setShowModal} iptv={e.iptv} />
    : <TarifCustomCard key={e.id} img={e.img} title={e.title} subTitle={e.subTitle}
        data={e.data} price={e.price} show={setShowModal} iptv={true} />;

  const modal = showModal && (
    <div className="form_container">
      <div className="form_block">
        <Form show={showModal} setShowModal={setShowModal} id={677} endpoint={'add_deal'} />
      </div>
    </div>
  );

  // Мобилка (≤768): единый свайп-вид вместо react-slick/iptv-flex/null.
  // Десктоп/планшет ниже не затрагиваем.
  if (isMobile) {
    // Нормализация по категории: 0/1 — TarifCard (API), 2/3 — галерея (хардкод).
    const tariffs =
      activeTitle === 0 ? (tarifCards ?? []).map((r) => normalizeTariff(r, 0)) :
      activeTitle === 1 ? (tarifYearCards ?? []).map((r) => normalizeTariff(r, 1)) :
      activeTitle === 2 ? (tarifIptvData ?? []).map(normalizeGalleryItem) :
      activeTitle === 3 ? (tarifAdditionallyData ?? []).map(normalizeGalleryItem) :
      activeTitle === 4 ? (tarifActionCards ?? []).map((r) => normalizeTariff(r, 4)) :
      [];

    // CTA → та же модалка, что у десктопной карточки этой категории:
    //  • IP TV «Базовый» (нет приставки) → ConnectModal /add_deal_iptv;
    //  • остальное (0/1, IP TV-приставка, Дополнительно) → общая Form-модалка.
    const handleConnect = (raw) => {
      if (activeTitle === 2 && !raw?.iptv) {
        setIptvModal({ open: true, serviceName: `IP TV ${raw.title}` });
      } else {
        setShowModal(true);
      }
    };

    return (
      <div className='tarifsCards_block'>
        <TarifsCardsMobile tariffs={tariffs} activeTitle={activeTitle} onConnect={handleConnect} />
        {modal}
        <ConnectModal
          isOpen={iptvModal.open}
          onClose={() => setIptvModal({ open: false, serviceName: '' })}
          serviceName={iptvModal.serviceName}
          interestedIn={0}
          apiEndpoint="/add_deal_iptv"
        />
      </div>
    );
  }

  // IPTV: если карточек <= 2 — просто flex по центру, без слайдера
  if (activeTitle === 2) {
    return (
      <div className='tarifsCards_block'>
        {iptvCount <= 2 ? (
          <div className="iptv-flex">
            {tarifIptvData?.map(renderIptvCard)}
          </div>
        ) : (
          <Slider {...{ ...settings, slidesToShow: Math.min(iptvCount, 2), autoplay: false }}>
            {tarifIptvData?.map(renderIptvCard)}
          </Slider>
        )}
        {modal}
      </div>
    );
  }

  if (activeTitle === 4 && actionsStatic) {
    return (
      <div className='tarifsCards_block'>
        <div className="iptv-flex">
          {tarifActionCards.map((e) => (
            <TarifCard tarifCards={e} show={setShowModal} key={e.id} />
          ))}
        </div>
        {modal}
      </div>
    );
  }

  const renderSlides = () => {
    if (activeTitle === 0) return tarifCards?.map((e) =>
      <TarifCard tarifCards={e} show={setShowModal} key={e.id} />);

    if (activeTitle === 1) return normalizedYearCards.map((e, i) =>
      <TarifCard tarifCards={e} show={setShowModal} key={`year-${e.id}-${i}`} />);

    // сюда попадаем, только если акций больше двух — тогда слайдер уместен
    if (activeTitle === 4) return tarifActionCards?.map((e) =>
      <TarifCard tarifCards={e} show={setShowModal} key={e.id} />);

    if (activeTitle === 3) return tarifAdditionallyData?.map((e) =>
      <TarifCustomCard key={e.id} img={e.img} title={e.title} subTitle={e.subTitle}
        data={e.data} price={e.price} longText={e.longText} show={setShowModal} dataText={e.dataText} />);

    return null;
  };

  return (
    <div className='tarifsCards_block'>
      <Slider {...settings}>
        {renderSlides()}
      </Slider>
      {modal}
    </div>
  );
};

export default TarifsCards;